import React, {useEffect, useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";
import {Grid, Table, TableBody, TableCell, TableHead, TableRow, makeStyles} from "@material-ui/core";
import axios from "axios";

import {CheckboxEditor, ComboSelect, FormDialog, FormMemo, FormSelect, LabelledPaper, MaskedNumber, MaskedText}from "../../../controls";
//import GenerateTripValidator from "../validators/GenerateTripValidator.js";
import { useAddFlightFixture, useContracts } from '../../../services/contracts';
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined } from '@material-ui/icons';
import GenerateFlightFixtureStyles from "../styles/GenerateFlightFixtureStyles";
import AwbStockSelector from '../../AwbStock/components/AwbStockSelector';
import AwbStockAllocationSelector from '../../AwbStock/AwbStockAllocationSelector';
import { v4 as uuidv4 } from 'uuid';

const SectionHeading = (props) => {
  const { children, ...other } = props;
  return (
    <div style={{marginTop: 10, marginBottom: 2, textAlign: "left", fontSize: "14px", fontWeight: "bold", ...other}}>
      {children}
    </div>
  );
}

const LabelledBox = (props) => {
  return (
    <LabelledPaper
      checkChildren={true}
      style={{display: "block", border: "solid 1px #b9b9b9" }}
      labelStyle={{background: "#f0f0f0"}}
      collapsible={false}
      {...__.omit(props, ['children'])}
    >
      {props.children}
    </LabelledPaper>
  )
}

const FlightDetails = (props) => {
  const {record, classes, changeRecord} = props;
  const {flightFixture} = record;
  if (!flightFixture) {
    return null;
  }

  const {tripNo, tripDate, tripRoute, clientCompanyUuid, clientCompanyName, clientContactName, clientContactPhone, clientContactEmail, awbNumbers, crewRestrictions} = flightFixture;

  const changeField = (fieldName, value) => {
    const newRecord = {...record};
    const {flightFixture} = newRecord;
    __.set(flightFixture, fieldName, value);
    changeRecord(newRecord);
  }

  return (
    <div>
      <SectionHeading>Flight Details</SectionHeading>
      <LabelledBox>
        <Table className={classes.scheduleLegs}>
          <TableBody>
          <TableRow>
              <TableCell width="200px" align="left">Routing</TableCell>
              <TableCell align="left">{tripRoute}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Trip Date</TableCell>
              <TableCell align="left">{moment(tripDate).format("DD MMM YYYY")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Trip Number</TableCell>
              <TableCell align="left">{tripNo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Client</TableCell>
              <TableCell align="left">{clientCompanyName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Client Contact</TableCell>
              <TableCell align="left">{clientContactName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Client Phone Number</TableCell>
              <TableCell align="left">{clientContactPhone}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Client Email Address</TableCell>
              <TableCell align="left">{clientContactEmail}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Air Waybill Requirement</TableCell>
              <TableCell align="left">
                <div style={{width: 200, display: "inline-block", verticalAlign: "top"}}>
                  <ComboSelect
                    id="awbNumbersType"
                    value={awbNumbers.type}
                    style={{padding: 2}}
                    group={"FLIGHT FIXTURE"}
                    subGroup="AWB REQUIREMENT TYPES"
                    onChange={(value) => {
                      changeField("awbNumbers.type", value);
                      changeField("awbNumbers.details.notes", "");
                      changeField("awbNumbers.details.allocation", {
                        awbAllocationUuid: null,
                        airportCode: "",
                        quantity: 0,
                        fromSerial: null,
                        toSerial: null,
                      });
                    }}
                  />
                </div>
                {awbNumbers.type === "OTHER"? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginLeft: 20, marginTop: 8}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="awbNumbersNotes"
                        value={awbNumbers.details?.notes}
                        style={{width: 600}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeField("awbNumbers.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                {awbNumbers.type === "ALLOTMENT"? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 70, marginLeft: 20, marginTop: 8}}>Allotment: </div>
                    <div style={{display: "inline-block", verticalAlign: "top", marginTop: 3}}>
                      <AwbStockAllocationSelector
                        classes={classes}
                        canEdit={true}
                        companyUuid={clientCompanyUuid}
                        returnType="object"
                        value={awbNumbers.details?.allotment?.awbAllocationUuid}
                        style={{width: 400}}
                        onChange={(_value)=>{
                          let value = _value;
                          if (!value) {
                            value = {
                              awbAllocationUuid: null,
                              airportCode: "",
                              quantity: 0,
                              fromSerial: null,
                              toSerial: null,
                            }
                          } else if (typeof value === "object" && value?.found) {
                            value = __.pick(value.data, ["awbAllocationUuid", "airportCode", "quantity", "fromSerial", "toSerial"]);
                          } else {
                            value = {
                              awbAllocationUuid: value,
                              airportCode: "",
                              quantity: 0,
                              fromSerial: null,
                              toSerial: null,
                            }
                          }
                          changeField("awbNumbers.details.allotment", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Crew Restrictions</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="crewRestrictionsRequired"
                    value={crewRestrictions.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeField("crewRestrictions.required", value);
                      changeField("crewRestrictions.details.notes", "");
                    }}
                  />
                </div>
                {crewRestrictions.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="crewRestrictionsNotes"
                        value={crewRestrictions.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeField("crewRestrictions.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </LabelledBox>
    </div>
  )
}

const CargoDetail = (props) => {
  const {record, cargoRecord, classes, changeRecord} = props;

  const {
    costingCargoUuid,
    originAirportCode,
    destinationAirportCode,
    payloadLoose,
    payloadUnitised,
    includeHandling,
    uldAllocation,
    shipperName,
    shipperUuid,
    shipperCompanyCode,
    shipperBranchCode,
    consigneeName,
    consigneeUuid,
    consigneeCompanyCode,
    consigneeBranchCode,
    notes,
    commodity,
    outsizedCargo,
    packingList,
    buildupPlan,
    outboundHandling,
    inboundHandling,
    attendants,
    cleaning,
    passes,
    photos
  } = cargoRecord;

  const changeCargoField = (fieldName, value) => {
    const newRecord = {...record};
    const cargoRecordIdx = __.findIndex(newRecord.flightFixture.cargo, {costingCargoUuid});
    if (cargoRecordIdx < 0) {
      return;
    }
    const cargoRecord = newRecord.flightFixture.cargo[cargoRecordIdx];

    __.set(cargoRecord, fieldName, value);
    changeRecord(newRecord);
  }

  return (
    <div>
      <SectionHeading>Cargo Details ({originAirportCode} - {destinationAirportCode})</SectionHeading>
      <LabelledBox>
        <Table className={classes.scheduleLegs}>
          <TableBody>
          <TableRow>
              <TableCell width="200px" align="left">Payload</TableCell>
              <TableCell align="left"><MaskedNumber value={payloadLoose + payloadUnitised} displayType="text" suffix= " kg"/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Commodity</TableCell>
              <TableCell align="left">
                <MaskedText
                  id="commodity"
                  value={commodity}
                  mask={"x".repeat(100)}
                  style={{width: 300}}
                  onChange={(value)=>{
                    changeCargoField("commodity", value);
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Primary Shipper</TableCell>
              <TableCell align="left">
                {shipperCompanyCode?`(${shipperCompanyCode}) `:null}{shipperName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Primary Consignee</TableCell>
              <TableCell align="left">
              {consigneeCompanyCode?`(${consigneeCompanyCode}) `:null}{consigneeName}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell width="200px" align="left">Consignee</TableCell>
              <TableCell align="left">{consignee}</TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell width="200px" align="left">Packing List</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="packingListProvided"
                    value={packingList.provided}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("packingList.provided", value);
                      changeCargoField("packingList.details.notes", "");
                    }}
                  />
                </div>
                {packingList.provided ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="packingListNotes"
                        value={packingList.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("packingList.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="middle" colSpan={2} style={{fontWeight: "700", textAlign: "center"}}>ULD Information</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left" >ULD Requirements</TableCell>
              <TableCell align="left">
                {uldAllocation && Array.isArray(uldAllocation) && uldAllocation.map((uldDetails, i) => (
                  <div style={{display: "inline-block"}}>
                    {i > 0 ? <div style={{display: "inline-block", paddingRight: 5}}>,</div> : null}
                    <div style={{display: "inline-block"}}>{uldDetails.quantity}</div><div style={{display: "inline-block", padding: 3}}>x</div><div style={{display: "inline-block"}}>{uldDetails.uldType}</div>
                  </div>
                ))}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Cargo Buildup Plan</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="buildupPlanProvided"
                    value={buildupPlan.provided}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("buildupPlan.provided", value);
                      changeCargoField("buildupPlan.details.notes", "");
                    }}
                  />
                </div>
                {buildupPlan.provided ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="buildupPlanNotes"
                        value={buildupPlan.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("buildupPlan.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Outsized / Specialized Cargo</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="outsizedCargoRequired"
                    value={outsizedCargo.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("outsizedCargo.required", value);
                      changeCargoField("outsizedCargo.details.notes", "");
                    }}
                  />
                </div>
                {outsizedCargo.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="outsizedCargoNotes"
                        value={outsizedCargo.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("outsizedCargo.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="middle" colSpan={2} style={{fontWeight: "700", textAlign: "center"}}>Handling Information</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Outbound Cargo Handling</TableCell>
              <TableCell align="left">
                <div style={{width: 200, display: "inline-block", verticalAlign: "top"}}>
                  <ComboSelect
                    id="outboundHandlingType"
                    value={outboundHandling.type}
                    style={{padding: 2}}
                    group={"FLIGHT FIXTURE"}
                    subGroup="CARGO HANDLING TYPES"
                    onChange={(value) => {
                      changeCargoField("outboundHandling.type", value);
                      changeCargoField("outboundHandling.details.notes", "");
                    }}
                  />
                </div>
                {outboundHandling.type !== "AIRLINE"? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="outboundHandlingNotes"
                        value={outboundHandling.details?.notes}
                        style={{width: 600}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("outboundHandling.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Inbound Cargo Handling</TableCell>
              <TableCell align="left">
                <div style={{width: 200, display: "inline-block", verticalAlign: "top"}}>
                  <ComboSelect
                    id="inboundHandlingType"
                    value={inboundHandling.type}
                    style={{padding: 2}}
                    group={"FLIGHT FIXTURE"}
                    subGroup="CARGO HANDLING TYPES"
                    onChange={(value) => {
                      changeCargoField("inboundHandling.type", value);
                      changeCargoField("inboundHandling.details.notes", "");
                    }}
                  />
                </div>
                {inboundHandling.type !== "AIRLINE"? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="inboundHandlingNotes"
                        value={inboundHandling.details?.notes}
                        style={{width: 600}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("inboundHandling.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="middle" colSpan={2} style={{fontWeight: "700", textAlign: "center"}}>Other Information</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Attendants</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="attendantsRequired"
                    value={attendants.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("attendants.required", value);
                      changeCargoField("attendants.details.notes", "");
                    }}
                  />
                </div>
                {attendants.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="attendantsNotes"
                        value={attendants.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("attendants.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Aircraft Cleaning</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="cleaningRequired"
                    value={cleaning.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("cleaning.required", value);
                      changeCargoField("cleaning.details.notes", "");
                    }}
                  />
                </div>
                {cleaning.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="cleaningNotes"
                        value={cleaning.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("cleaning.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Airport passes required</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="passesRequired"
                    value={passes.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("passes.required", value);
                      changeCargoField("passes.details.notes", "");
                    }}
                  />
                </div>
                {passes.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="passesNotes"
                        value={passes.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("passes.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="200px" align="left">Photos Required</TableCell>
              <TableCell align="left">
                <div style={{width: 50, display: "inline-block", verticalAlign: "top"}}>
                  <CheckboxEditor
                    id="photosRequired"
                    value={photos.required}
                    style={{padding: 2}}
                    onChange={(value) => {
                      changeCargoField("photos.required", value);
                      changeCargoField("photos.details.notes", "");
                    }}
                  />
                </div>
                {photos.required ? (
                  <div style={{display: "inline-block"}}>
                    <div style={{display: "inline-block", verticalAlign: "top", width: 50, marginTop: 5}}>Notes: </div>
                    <div style={{display: "inline-block", verticalAlign: "top"}}>
                      <FormMemo
                        id="photosNotes"
                        value={photos.details?.notes}
                        style={{width: 800}}
                        onChange={(event)=>{
                          const value = event.target.value;
                          changeCargoField("photos.details.notes", value);
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </LabelledBox>
    </div>
  )
}

const CargoDetails = (props) => {
    const {record, classes, changeRecord} = props;
    const {flightFixture} = record;
    if (!flightFixture) {
      return null;
    }

    const {cargo} = flightFixture;

    return (
      <>
      {cargo.map((cargoRecord, i) => (
        <CargoDetail key={i} record={record} cargoRecord={cargoRecord} classes={classes} changeRecord={changeRecord}/>
      ))}
      </>
    )
}

const TripSchedule = (props) => {
  const {record, classes} = props;
  const {flightFixture} = record;
  if (!flightFixture) {
    return null;
  }
  const {legs} = flightFixture;
  if (!legs || !legs.length) {
    return null;
  }

  return (
    <div>
      <SectionHeading>Schedule (All times are in UTC)</SectionHeading>
      <LabelledBox>
        <Table className={classes.scheduleLegs}>
          <TableHead>
            <TableRow>
              <TableCell width="80px" align="left">Date</TableCell>
              <TableCell width="100px" align="left">Flight No.</TableCell>
              <TableCell width="80px" align="middle">STD</TableCell>
              <TableCell width="80px" align="middle">Origin</TableCell>
              <TableCell width="80px" align="middle">Dest</TableCell>
              <TableCell width="80px" align="middle">STA</TableCell>
              <TableCell align="left">Type</TableCell>
              <TableCell width="60px" align="middle">Load</TableCell>
              <TableCell width="60px" align="middle">Thru</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {legs.map((sector) => {
              const {
                airlineCode,
                flightNo,
                originAirportCode,
                destinationAirportCode,
                alternateAirportCode,
                scheduledDepartureTimeUTC,
                scheduledArrivalTimeUTC,
                legType,
                allowLoading,
                allowThroughCargo
              } = sector;
              return (
              <TableRow>
                <TableCell width="80px" align="left">{moment(scheduledDepartureTimeUTC).format('DD MMM YYYY')}</TableCell>
                <TableCell width="80px" align="left">{airlineCode}{flightNo}</TableCell>
                <TableCell width="80px" align="middle">{moment(scheduledDepartureTimeUTC).format('HH:mm')}</TableCell>
                <TableCell width="80px" align="middle">{originAirportCode}</TableCell>
                <TableCell width="80px" align="middle">{destinationAirportCode}</TableCell>
                <TableCell width="80px" align="middle">{moment(scheduledArrivalTimeUTC).format('HH:mm')}</TableCell>
                <TableCell align="left">{legType}</TableCell>
                <TableCell width="60px" align="middle">{allowLoading ? <CheckBoxOutlined/> : <CheckBoxOutlineBlankOutlined/>}</TableCell>
                <TableCell width="60px" align="middle">{allowThroughCargo ? <CheckBoxOutlined/> : <CheckBoxOutlineBlankOutlined/>}</TableCell>
              </TableRow>
            )})}
          </TableBody>
        </Table>
      </LabelledBox>
    </div>
  )

}

const SelectTripScratchPad = (props) => {
  const {onChange, options, value, fullWidth} = props;
  return (
    <FormSelect
      name="scratchPad"
      label="Scratch Pad"
      value={value}
      fullWidth={fullWidth}
      style={{width: "100%"}}
      onChange={onChange}
      options={options}
    />
  );
}
const GenerateFlightFixtureDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }
  const apiSitePrefix = props.apiSitePrefix
  const SystemData = props.SystemData;
  const classes = makeStyles(GenerateFlightFixtureStyles)();

  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    rowData: null,
    title: 'Generate Flight Fixture',
  });

  const [scratchPadOptions, setScratchPadOptions] = useState(null);

  const queryClient = useQueryClient();

//  const contract = useContracts({queryClient, extraKeys: [dialogStates.record?.contractUuid], useCache: false});

  const handleAddFlightFixture = useAddFlightFixture();

  const buildFlightFixture = async (record) => {
    try {
      const tripOptions = await axios.get(`${apiSitePrefix}/trip/lookup/${record.tripNo}`);
      if (!tripOptions?.data || !tripOptions?.data?.found) {
        return {flightFixture: null, tripUuid: null, schedulingScratchPadUuid: null, scratchPadOptions: []};
      }
      const options = tripOptions.data?.options.map((tripOption) => {
        return {
          code: `${tripOption.schedulingScratchPadUuid}`,
          value: `${tripOption.label}`,
          data: tripOption
        }
      });

      if (!options || options.length < 1) {
        return {flightFixture: null, tripUuid: null, schedulingScratchPadUuid: null, scratchPadOptions: []};
      }
      const tripOptionsData = tripOptions.data.options;
      let scratchPadIdx = __.findIndex(tripOptionsData, {schedulingScratchPadUuid: record?.schedulingScratchPadUuid});
      if (scratchPadIdx < 0) {
        scratchPadIdx = 0;
      }
      const tripUuid = tripOptionsData[scratchPadIdx].tripUuid;
      const schedulingScratchPadUuid = tripOptionsData[scratchPadIdx].type === "scratchpad" ? tripOptionsData[scratchPadIdx].schedulingScratchPadUuid : null;

      const flightFixture = await axios.get(`${apiSitePrefix}/flightfixtures/build/${record.contractUuid}/${tripUuid || "NULL"}/${schedulingScratchPadUuid || "NULL"}`);
      return {flightFixture: flightFixture.data, tripUuid, schedulingScratchPadUuid, scratchPadOptions: options};
    } catch (error) {
      console.error('ERROR', error);
      if (!error?.response?.data) {
        SystemData.alert("Error", `Generating trip has failed. Server is not responding`);
        SystemData.toggleLoadingProgress(false);
      } else if (error?.response?.data?.errorMessage) {
        SystemData.alert("Error", `Generating trip has failed. ${error.response.data.errorMessage}`);
        SystemData.toggleLoadingProgress(false);
      } else {
        SystemData.alert("Error", `Generating trip has failed. An unexpected error has occurred.`);
        SystemData.toggleLoadingProgress(false);
      }
      return null;
    }
  }

  const lastRequest = useRef(null);
  const getFlightFixture = ((record, changeRecord) => {
    let requestUuid = uuidv4();
    lastRequest.current = requestUuid;
    buildFlightFixture(record).then((data) => {
      if (lastRequest.current !== requestUuid) {
        return;
      }
      const newRecord = {...record, ...__.omit(data, ['scratchPadOptions'])};
      changeRecord(newRecord);
      setScratchPadOptions(data?.scratchPadOptions);
    });
  });

  useEffect(()=> {
    const open = async (rowData) => {
      let record = {...__.pick(rowData, ['contractUuid', 'tripNo', 'schedulingScratchPadUuid'])};
      setDialogStates({...dialogStates, showDialog:true, record, rowData, title: `Generate New Flight Fixture for ${rowData.contractName}`});
    }
    eventBus.bind("GenerateFlightFixtureDialog.open", open);
    return () => {
      eventBus.unbind("GenerateFlightFixtureDialog.open", open);
    }
  }, [SystemData, apiSitePrefix, dialogStates, eventBus]);

  const handleSave = async (record) => {
    try {
      const oldData = record.flightFixture;
      const newData = {...record.flightFixture};

      handleAddFlightFixture.mutate({
        extraKeys:[],
        record: newData,
        oldRecord: oldData,
        postSuccess: (data) => {
          if (data && data.record && data.record.data && data.status === "SUCCESS") {
            queryClient.invalidateQueries(["FlightFixtures"]);
            if (props.postSave) {
              props.postSave({flightFixture: data.record.data, rowData: dialogStates.rowData});
            }
            setDialogStates({...dialogStates, showDialog: false, record: null});
          } else {
            console.log(data);
            SystemData.alert("Error", `Saving Flight Fixture has failed. ${data?.errorMessage}`);
          }
        },
        postError: (data) => {
          if (data.errorMessage) {
            SystemData.alert("Error", `Saving Flight Fixture has failed. ${data.errorMessage}`);
          } else {
            SystemData.alert("Error", `Saving Flight Fixture has failed. An unexpected error has occurred.`);
          }
        }
      });
    } catch (err) {
      SystemData.alert("Error", `Saving Flight Fixture has failed. An unexpected error has occurred.`);
      console.error(err);
    }
  }

  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message="Please select the trip to generate a flight fixture from"
        open={dialogStates.showDialog}
        record={__.cloneDeep(dialogStates.record)}
        dialogOptions={{width: "lg", maxWidth: "lg", fullWidth: true}}
        classes={classes}
//        validator={GenerateTripValidator}
        buttons = {{
          save:{icon: "check_circle", key: "Send", label: "Send", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error;
          }},
          cancel:{icon: "check_circle", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            handleSave(record);
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                {/* <label htmlFor="tripNo" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Trip Number
                </label>
 */}
                <MaskedText
                  id="tripNo"
                  label="Trip Number"
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  mask={`MAG________`}
                  maskChar={""}
                  alwaysShowMask={false}
                  formatChars={{'_':'[0-9]'}}
                  forceUpperCase={true}
                  defaultValue=""
                  inputLabelProps={{shrink: true}}
                  onChange={async (tripNo, params) => {
                    if (tripNo) {
                      let newRecord = __.cloneDeep(params.record);
                      newRecord['tripNo'] = tripNo;
                      getFlightFixture(newRecord, params.recordChange);
                      newRecord = {...newRecord};
                      params.recordChange(newRecord);
                    }
                  }}
                />
              </div>
            )}
          </Grid>
          <Grid item checkChildren={true} xs={4}>
            <div style={{paddingLeft: 0, display: "inline-block", width: "100%"}}>
            <SelectTripScratchPad
              label="Scratch Pad"
              id="schedulingScratchPadUuid"
              options={scratchPadOptions}
              fullWidth={true}
              onChange={(value, params) => {
                let newRecord = __.cloneDeep(params.record);
                getFlightFixture(newRecord, params.recordChange);
                newRecord['schedulingScratchPadUuid'] = value;
                params.recordChange(newRecord);
              }}
            />
            </div>
          </Grid>
          <Grid item checkChildren={true} xs={12}>
            {(record, changeRecord) => (
              <FlightDetails
                id={"flightDetails"}
                record={record}
                classes={classes}
                changeRecord={changeRecord}
              />
            )}
          </Grid>
          <Grid item checkChildren={true} xs={12}>
            {(record) => (
              <TripSchedule
                id={"legs"}
                record={record}
                classes={classes}
              />
            )}
          </Grid>
          <Grid item checkChildren={true} xs={12}>
            {(record, changeRecord) => (
              <CargoDetails
                id={"cargo"}
                record={record}
                classes={classes}
                changeRecord={changeRecord}
              />
            )}
          </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default GenerateFlightFixtureDialog;
